var _g, _g2, _path, _path2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaneja(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 80,
    viewBox: "0 0 180 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_611_10196",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 0,
    width: 99,
    height: 28
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c6c4e168fe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.7388 0H148.511V27.3417H50.7388V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_611_10196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M89.3314 9.09627C101.657 9.09627 112.261 16.4577 116.986 27.0184H148.498L121.184 22.5047C120.639 18.712 119.783 14.9752 118.622 11.3353C116.724 12.6216 114.819 13.8978 112.919 15.1815C109.531 9.70506 105.399 4.75074 100.677 0.451066C99.6756 2.5143 98.6618 4.57244 97.6608 6.63313C91.9856 3.58413 85.9309 1.36042 79.6877 -0.00488281C79.8533 2.28251 80.0087 4.56989 80.1691 6.85473C73.7298 7.05087 67.372 8.15126 61.2842 10.0897C62.5731 11.9873 63.8492 13.8901 65.1355 15.7878C60.0488 18.9336 55.4154 22.7162 51.3348 27.0184H61.6739C66.4015 16.4577 77.0055 9.09627 89.3314 9.09627Z",
    fill: "black"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M89.3315 13.8691C79.7234 13.8691 71.3584 19.1775 67.0078 27.0178H76.1879C79.4789 23.5205 84.1479 21.335 89.3315 21.335C94.5125 21.335 99.1841 23.5205 102.475 27.0178H111.653C107.302 19.1775 98.937 13.8691 89.3315 13.8691Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M90.9336 58.6545C85.7501 58.6545 81.0811 56.469 77.7901 52.9717H68.61C72.9606 60.812 81.3256 66.1203 90.9336 66.1203C100.539 66.1203 108.904 60.812 113.255 52.9717H104.077C100.786 56.469 96.1147 58.6545 90.9336 58.6545Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_611_10196",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 52,
    width: 98,
    height: 28
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "740f868ed1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.7621 52.7734H128.989V80.0005H31.7621V52.7734Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_611_10196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M90.9337 70.8938C78.6077 70.8938 68.0037 63.5324 63.2761 52.9717H31.7672L59.0783 57.4853C59.6234 61.2781 60.4818 65.0149 61.6408 68.6548C63.5385 67.3685 65.4463 66.0923 67.344 64.8085C70.7343 70.285 74.8659 75.2393 79.5884 79.539C80.5895 77.4758 81.6007 75.4176 82.6043 73.3569C88.2795 76.4059 94.3342 78.6297 100.575 79.995C100.409 77.7076 100.256 75.4202 100.093 73.1353C106.535 72.9392 112.891 71.8388 118.978 69.9004C117.692 68.0053 116.413 66.1 115.13 64.1997C120.216 61.0565 124.85 57.2714 128.93 52.9717H118.591C113.864 63.5324 103.26 70.8938 90.9337 70.8938Z",
    fill: "black"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.16426 45.1929H2.99404V36.7565H0.212494V34.9531H7.9458V36.7565H5.16426V45.1929Z",
    fill: "black"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.7935 45.1926L15.0497 42.7575H11.3206L10.5768 45.1926H8.2334L11.8504 34.9121H14.4995L18.1267 45.1926H15.7935ZM14.5301 40.9337C13.8423 38.7278 13.4552 37.4797 13.3686 37.1944C13.287 36.904 13.2259 36.6722 13.1852 36.5016C13.0272 37.1002 12.5866 38.5775 11.8606 40.9337H14.5301Z",
    fill: "black"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M28.5017 45.1929H25.7405L21.288 37.4494H21.2269C21.3135 38.8147 21.3593 39.7903 21.3593 40.3736V45.1929H19.4234V34.9531H22.154L26.6065 42.6253H26.6575C26.5811 41.2957 26.5454 40.3532 26.5454 39.803V34.9531H28.5017V45.1929Z",
    fill: "black"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M36.9735 45.1929H31.0844V34.9531H36.9735V36.726H33.2546V38.9777H36.7188V40.7607H33.2546V43.3996H36.9735V45.1929Z",
    fill: "black"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M38.0374 48.2088C37.5483 48.2088 37.1204 48.1578 36.7536 48.0559V46.2423C37.128 46.3366 37.4719 46.385 37.7827 46.385C38.2565 46.385 38.5978 46.2347 38.8016 45.9367C39.0104 45.6437 39.1174 45.1827 39.1174 44.551V34.9531H41.2876V44.5306C41.2876 45.7252 41.0125 46.6346 40.4623 47.2612C39.9172 47.8929 39.1098 48.2088 38.0374 48.2088Z",
    fill: "black"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M50.132 45.1926L49.3882 42.7575H45.6591L44.9153 45.1926H42.5719L46.1889 34.9121H48.838L52.4652 45.1926H50.132ZM48.8686 40.9337C48.1808 38.7278 47.7936 37.4797 47.707 37.1944C47.6255 36.904 47.5644 36.6722 47.5236 36.5016C47.3657 37.1002 46.925 38.5775 46.1991 40.9337H48.8686Z",
    fill: "black"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M57.4878 45.1929V34.9531H59.658V45.1929H57.4878Z",
    fill: "black"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M64.4064 39.4973H65.0993C65.7845 39.4973 66.2914 39.3853 66.6174 39.1611C66.9485 38.9319 67.1167 38.5676 67.1167 38.0709C67.1167 37.5895 66.946 37.2456 66.6072 37.0418C66.2735 36.833 65.7565 36.726 65.0585 36.726H64.4064V39.4973ZM64.4064 41.26V45.1929H62.2362V34.9531H65.2114C66.6021 34.9531 67.6312 35.2078 68.2986 35.7173C68.971 36.2216 69.3073 36.9883 69.3073 38.02C69.3073 38.6262 69.1391 39.1611 68.808 39.6298C68.4743 40.0985 68.0056 40.4653 67.4019 40.7302C68.943 43.0329 69.9492 44.5204 70.4178 45.1929H68.0031L65.5578 41.26H64.4064Z",
    fill: "black"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M80.9973 40.0577C80.9973 41.7566 80.5744 43.0608 79.7339 43.9702C78.8907 44.8821 77.6859 45.3355 76.1168 45.3355C74.5478 45.3355 73.3404 44.8821 72.4998 43.9702C71.6643 43.0608 71.2466 41.7541 71.2466 40.0475C71.2466 38.3434 71.6669 37.0418 72.51 36.1452C73.3506 35.2434 74.5605 34.79 76.1372 34.79C77.7063 34.79 78.9086 35.246 79.7441 36.1553C80.5795 37.0596 80.9973 38.3612 80.9973 40.0577ZM73.5187 40.0577C73.5187 41.1988 73.7352 42.0623 74.1708 42.6456C74.6038 43.2238 75.2533 43.5117 76.1168 43.5117C77.8489 43.5117 78.715 42.3603 78.715 40.0577C78.715 37.7499 77.854 36.5935 76.1372 36.5935C75.2737 36.5935 74.6216 36.8864 74.181 37.4697C73.7377 38.0556 73.5187 38.9165 73.5187 40.0577Z",
    fill: "black"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M92.199 45.1929H89.4379L84.9853 37.4494H84.9242C85.0108 38.8147 85.0567 39.7903 85.0567 40.3736V45.1929H83.1208V34.9531H85.8514L90.3039 42.6253H90.3549C90.2784 41.2957 90.2428 40.3532 90.2428 39.803V34.9531H92.199V45.1929Z",
    fill: "black"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M107.973 45.1924H105.334L104.529 44.3977C103.633 45.0243 102.624 45.335 101.503 45.335C100.362 45.335 99.4552 45.0752 98.7828 44.5505C98.1154 44.0283 97.7843 43.3177 97.7843 42.421C97.7843 41.7842 97.9269 41.2391 98.2122 40.7908C98.4975 40.3425 98.9815 39.9222 99.6692 39.5274C99.3151 39.1275 99.0579 38.7429 98.8949 38.3761C98.7369 38.0093 98.6605 37.6094 98.6605 37.1738C98.6605 36.4606 98.9305 35.8875 99.4756 35.4519C100.026 35.0189 100.754 34.7998 101.666 34.7998C102.527 34.7998 103.22 35.0036 103.745 35.4111C104.267 35.8136 104.529 36.3536 104.529 37.0312C104.529 37.589 104.366 38.0984 104.04 38.5595C103.719 39.0154 103.2 39.451 102.481 39.8636L104.468 41.8097C104.799 41.2595 105.09 40.5565 105.334 39.7006H107.555C107.392 40.3323 107.161 40.9488 106.863 41.5448C106.57 42.1434 106.236 42.6758 105.864 43.1444L107.973 45.1924ZM100.036 42.2173C100.036 42.6248 100.184 42.9483 100.484 43.1852C100.79 43.4246 101.177 43.5418 101.646 43.5418C102.237 43.5418 102.767 43.3992 103.235 43.1139L100.912 40.801C100.64 41.0048 100.426 41.2188 100.27 41.4429C100.112 41.6671 100.036 41.9269 100.036 42.2173ZM102.553 37.2553C102.553 37.0108 102.466 36.8172 102.298 36.6745C102.127 36.5319 101.911 36.4606 101.646 36.4606C101.333 36.4606 101.085 36.537 100.902 36.6847C100.724 36.835 100.637 37.0464 100.637 37.3164C100.637 37.7316 100.861 38.1876 101.31 38.6817C101.71 38.4576 102.015 38.2385 102.227 38.0195C102.443 37.803 102.553 37.5482 102.553 37.2553Z",
    fill: "black"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M119.033 42.3497C119.033 43.2743 118.699 44.0054 118.035 44.5403C117.367 45.0701 116.44 45.335 115.253 45.335C114.158 45.335 113.195 45.1287 112.359 44.7135V42.6961C113.045 43.0094 113.625 43.231 114.102 43.3584C114.583 43.4807 115.024 43.5418 115.426 43.5418C115.9 43.5418 116.264 43.4501 116.516 43.2667C116.774 43.0833 116.904 42.8133 116.904 42.4516C116.904 42.2555 116.845 42.0797 116.73 41.9218C116.621 41.7664 116.458 41.6161 116.241 41.4735C116.022 41.3257 115.582 41.0914 114.917 40.7704C114.285 40.4801 113.811 40.1973 113.501 39.9248C113.187 39.6548 112.935 39.3389 112.747 38.9772C112.563 38.6181 112.471 38.1978 112.471 37.7138C112.471 36.8121 112.777 36.1014 113.388 35.5843C114.005 35.0622 114.858 34.7998 115.946 34.7998C116.476 34.7998 116.98 34.866 117.464 34.9934C117.945 35.1233 118.452 35.2991 118.982 35.5232L118.279 37.2146C117.734 36.9904 117.283 36.835 116.924 36.7459C116.57 36.6593 116.221 36.6134 115.875 36.6134C115.459 36.6134 115.143 36.7102 114.927 36.8987C114.708 37.0897 114.601 37.3419 114.601 37.6527C114.601 37.8437 114.644 38.0093 114.733 38.1519C114.82 38.2946 114.96 38.4347 115.151 38.5697C115.347 38.6996 115.806 38.9365 116.527 39.2829C117.484 39.7388 118.139 40.1973 118.493 40.6584C118.852 41.122 119.033 41.6849 119.033 42.3497Z",
    fill: "black"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M124.834 45.1929H122.664V36.7565H119.882V34.9531H127.616V36.7565H124.834V45.1929Z",
    fill: "black"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M135.086 45.1929H129.197V34.9531H135.086V36.726H131.367V38.9777H134.832V40.7607H131.367V43.3996H135.086V45.1929Z",
    fill: "black"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M143.119 45.1929H137.23V34.9531H143.119V36.726H139.401V38.9777H142.865V40.7607H139.401V43.3996H143.119V45.1929Z",
    fill: "black"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M145.263 45.1929V34.9531H147.434V43.3996H151.581V45.1929H145.263Z",
    fill: "black"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M161.433 36.6134C160.618 36.6134 159.986 36.9242 159.538 37.5406C159.089 38.1519 158.865 39.0052 158.865 40.098C158.865 42.3803 159.721 43.5214 161.433 43.5214C162.151 43.5214 163.025 43.3431 164.051 42.9814V44.8052C163.208 45.1593 162.271 45.335 161.239 45.335C159.744 45.335 158.603 44.8842 157.816 43.9799C157.026 43.0782 156.634 41.7791 156.634 40.0878C156.634 39.0231 156.828 38.0882 157.215 37.2859C157.602 36.4861 158.157 35.8696 158.886 35.4417C159.612 35.0138 160.46 34.7998 161.433 34.7998C162.431 34.7998 163.432 35.0418 164.439 35.5232L163.736 37.2859C163.353 37.1101 162.966 36.9547 162.574 36.8172C162.187 36.6822 161.805 36.6134 161.433 36.6134Z",
    fill: "black"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M175.524 40.0577C175.524 41.7566 175.101 43.0608 174.261 43.9702C173.418 44.8821 172.213 45.3355 170.644 45.3355C169.075 45.3355 167.867 44.8821 167.027 43.9702C166.191 43.0608 165.774 41.7541 165.774 40.0475C165.774 38.3434 166.194 37.0418 167.037 36.1452C167.878 35.2434 169.088 34.79 170.664 34.79C172.233 34.79 173.436 35.246 174.271 36.1553C175.107 37.0596 175.524 38.3612 175.524 40.0577ZM168.046 40.0577C168.046 41.1988 168.262 42.0623 168.698 42.6456C169.131 43.2238 169.78 43.5117 170.644 43.5117C172.376 43.5117 173.242 42.3603 173.242 40.0577C173.242 37.7499 172.381 36.5935 170.664 36.5935C169.801 36.5935 169.149 36.8864 168.708 37.4697C168.265 38.0556 168.046 38.9165 168.046 40.0577Z",
    fill: "black"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M177.169 44.194C177.169 43.8018 177.274 43.5063 177.485 43.3076C177.694 43.1038 178 43.002 178.402 43.002C178.794 43.002 179.097 43.1038 179.309 43.3076C179.518 43.5114 179.625 43.8069 179.625 44.194C179.625 44.5608 179.515 44.8538 179.299 45.0703C179.087 45.2792 178.789 45.3861 178.402 45.3861C178.015 45.3861 177.712 45.2792 177.495 45.0703C177.276 44.8614 177.169 44.5685 177.169 44.194Z",
    fill: "black"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaneja);
export default __webpack_public_path__ + "static/media/taneja.13f69e719b81ccc484597d7ccdb28c5e.svg";
export { ForwardRef as ReactComponent };